const Mail = ({ type }) => {
  const regular = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.1875 7.73538L11.8596 12.5256C12.2449 12.8022 12.7551 12.8022 13.1404 12.5256L19.8125 7.73538M5.75 19.9854H19.25C20.4926 19.9854 21.5 18.9407 21.5 17.652V8.31872C21.5 7.03005 20.4926 5.98538 19.25 5.98538H5.75C4.50736 5.98538 3.5 7.03005 3.5 8.31872V17.652C3.5 18.9407 4.50736 19.9854 5.75 19.9854Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Mail;
